/** @jsxImportSource @emotion/react */
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router";

import { css } from "@emotion/react";

import TextLink from "../../../../components/TextLink/TextLink";
import { TEXT_LINK_SIZES } from "../../../../components/TextLink/types";
import { ROUTES } from "../../../../shared";

interface ForgotPasswordProps {
  isDisabled?: boolean;
}

const ForgotPassword = ({ isDisabled }: ForgotPasswordProps) => {
  const { t } = useTranslation();

  return (
    <TextLink
      component={RouterLink}
      to={ROUTES.RequestReset}
      underline="none"
      size={TEXT_LINK_SIZES.Normal}
      css={css({ margin: "4px 0 16px 0" })}
      isDisabled={isDisabled}
    >
      {t("Auth##forgot password")}
    </TextLink>
  );
};

export default ForgotPassword;
